import type { LucideIcon } from 'lucide-react';
import {
  CALL_ANALYSIS_TAG_ICON_PICKER_OPTIONS,
  resolveCallAnalysisTagIconName,
  type CallAnalysisTagIconLegacyName,
  type CallAnalysisTagIconPickerName,
  type CallAnalysisTagResolvedIconName,
} from '@reach/shared-types/call-analysis-tag-icon-picker';
import {
  AlertCircle,
  AlertTriangle,
  ArrowDown,
  ArrowUp,
  Ban,
  Bell,
  Bookmark,
  Briefcase,
  Building2,
  Calendar,
  CalendarClock,
  Check,
  CheckCircle,
  ClipboardList,
  Clock,
  CreditCard,
  Droplets,
  Eye,
  Flag,
  Flame,
  Forward,
  Hash,
  HelpCircle,
  Home,
  Info,
  Leaf,
  ListTodo,
  Mail,
  MapPin,
  Megaphone,
  MessageSquare,
  Minus,
  Package,
  Phone,
  PhoneForwarded,
  PhoneOff,
  Receipt,
  Settings,
  Shield,
  Sparkles,
  Star,
  Tag,
  ThumbsDown,
  ThumbsUp,
  User,
  UserCheck,
  UserPlus,
  Users,
  UserX,
  Wrench,
  XCircle,
  Zap,
} from 'lucide-react';

const PICKER_ICONS = {
  UserPlus,
  UserCheck,
  UserX,
  Briefcase,
  Megaphone,
  Ban,
  PhoneOff,
  Building2,
  Settings,
  Sparkles,
  Wrench,
  Calendar,
  CalendarClock,
  CreditCard,
  Receipt,
  Info,
  HelpCircle,
  MessageSquare,
  Forward,
  User,
  XCircle,
  Flame,
  Zap,
  AlertTriangle,
  ArrowUp,
  Minus,
  ArrowDown,
  Phone,
  ListTodo,
  PhoneForwarded,
  Bell,
  CheckCircle,
  Check,
  Tag,
  Hash,
  Bookmark,
  Flag,
  MapPin,
  Star,
  Package,
  Home,
  Users,
  Mail,
  Clock,
  ClipboardList,
} satisfies Record<CallAnalysisTagIconPickerName, LucideIcon>;

const LEGACY_ICONS = {
  AlertCircle,
  Shield,
  ThumbsUp,
  ThumbsDown,
  Leaf,
  Droplets,
  Eye,
} satisfies Record<CallAnalysisTagIconLegacyName, LucideIcon>;

const RESOLVABLE_ICONS: Record<CallAnalysisTagResolvedIconName, LucideIcon> = {
  ...PICKER_ICONS,
  ...LEGACY_ICONS,
};

export type TagIconOption = {
  name: string;
  Icon: LucideIcon;
  label: string;
};

export const TAG_ICON_OPTIONS: TagIconOption[] = CALL_ANALYSIS_TAG_ICON_PICKER_OPTIONS.map(o => ({
  name: o.name,
  label: o.label,
  Icon: PICKER_ICONS[o.name],
}));

export function resolveTagIcon(name: string): LucideIcon | null {
  const resolvedName = resolveCallAnalysisTagIconName(name);
  if (!resolvedName) return null;
  return RESOLVABLE_ICONS[resolvedName];
}
